import z from "zod";

const translationPath = "page.4uDlist.generationRule.beneficiary.errors.";

export const beneficiarySchema = z.object({
  id: z.string().optional(),
  ownership: z.string().min(1, { message: translationPath + "ownership" }),
});

export type TBeneficiaryForm = z.infer<typeof beneficiarySchema>;
